/**
 * Search input component for filtering articles
 */

import { Input } from '@/components/ui/input';

interface FilterSearchProps {
  query: string;
  onQueryChange: (query: string) => void;
  placeholder?: string;
}

export function FilterSearch({
  query,
  onQueryChange,
  placeholder = 'Search articles by title, author or content...',
}: FilterSearchProps) {
  return (
    <div className="w-full max-w-sm">
      <label htmlFor="article-search" className="sr-only">
        Search articles
      </label>
      <Input
        id="article-search"
        type="search"
        value={query}
        placeholder={placeholder}
        onChange={event => onQueryChange(event.target.value)}
        autoComplete="off"
      />
    </div>
  );
}

